export default __webpack_public_path__ + "locales/zh-CN/UploadPanel.json?hash=5cddc0cc870108978470a5f77dfc9505";